"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBuildContext = exports.createVisitorContext = void 0;
const common_1 = require("@finley-technologies/common");
const utils_1 = require("../../utils");
const createVisitorContext = () => {
    const visitorHistory = [];
    let currentNodeDepth = 0;
    return {
        enterNode: (node, nestedContext) => {
            // Record entry into current node
            visitorHistory.push({
                action: 'enter',
                nodeType: node.type,
                nodeContent: (0, utils_1.getNodeContent)(node),
                nodeDepth: currentNodeDepth,
            });
            // Depth first search, parent has been entered, now go one level lower to children
            if (nestedContext) {
                currentNodeDepth += 1;
            }
        },
        exitNode: (node, nestedContext) => {
            // Depth first search, all children have been visited, return one level higher to parent
            if (nestedContext) {
                currentNodeDepth -= 1;
            }
            // Record exit from current node
            visitorHistory.push({
                action: 'exit',
                nodeType: node.type,
                nodeContent: (0, utils_1.getNodeContent)(node),
                nodeDepth: currentNodeDepth,
            });
        },
        history: visitorHistory,
    };
};
exports.createVisitorContext = createVisitorContext;
const createBuildContext = (formula) => {
    const functionStack = [];
    const rangeVariables = new Set();
    const rowVariables = new Set();
    return {
        rangeVariables: {
            add: (variable) => rangeVariables.add(variable),
            getAll: () => Array.from(rangeVariables),
        },
        rowVariables: {
            add: (variable) => rowVariables.add(variable),
            getAll: () => Array.from(rowVariables),
        },
        functionStack,
        getFormulaFunction: () => {
            const stackItem = functionStack.pop();
            (0, common_1.finleyAssert)(stackItem, 'Unable to generate formula');
            // Validate result store has no functions remaining on the stack
            const functionCount = functionStack.length;
            (0, common_1.finleyAssert)(functionCount === 0, new common_1.error.FinleyError(`Formula generation failure`, {
                metadata: {
                    logMeta: { formula, remainingFunctionCount: functionCount },
                },
            }));
            return stackItem.evaluatorFunction;
        },
    };
};
exports.createBuildContext = createBuildContext;
//# sourceMappingURL=context.js.map